// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const potashPit = defineModel({
  id: "potash-pit",
  batchId: "future",
  name: "Potash pit",
  tags: ["scenery","potash","pit","low-poly","age-of-mcp","future"],
  summary: "A wood-ash leaching pit. Potash for glass, soap and lye, fertiliser and bleaching cloth.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.4,
  parts: () => [
      { geometry: new THREE.CylinderGeometry(0.36, 0.34, 0.18, 10), color: "#5a4a36", position: [0, 0.09, 0] },
      { geometry: new THREE.CylinderGeometry(0.28, 0.3, 0.12, 10), color: "#b9b3a6", position: [0, 0.14, 0] },
      { geometry: new THREE.ConeGeometry(0.16, 0.12, 8), color: "#cdc7ba", position: [0, 0.2, 0] },
      { geometry: new THREE.IcosahedronGeometry(0.05, 0), color: "#7a4a30", position: [0.1, 0.16, 0.06] },
      { geometry: new THREE.CylinderGeometry(0.06, 0.05, 0.1, 7), color: "#7a5a36", position: [0.32, 0.2, 0] },
    ],
  animations: [],
});
